import React from "react";

const InfoModal = ({ isOpen, onClose, program_details }) => {
  if (!isOpen || !program_details || program_details.length === 0) {
    return null;
  }

  

  const { program_name, description, image_full_url } = program_details;

  return (
    <div
      className="modal fade show replace-exercise-modal"
      style={{ display: "block" }}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          {/* Modal Header */}
          <div className="modal-header">
            <h5 className="modal-title text-center w-100">Program Details</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          {/* Modal Body */}
          <div className="modal-body">
            <div className="text-center mb-4">
              {image_full_url ? (
                <img
                  src={image_full_url}
                  alt={program_name}
                  className="img-fluid rounded"
                  style={{ maxHeight: "200px", objectFit: "cover" }}
                />
              ) : (
                <div
                  style={{
                    height: "200px",
                    width: "200px",
                    margin: 'auto',
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#f5f5f5",
                    border: "1px dashed #ccc",
                    borderRadius: "5px",
                  }}
                >
                  <span style={{ color: "#999", fontSize: "16px" }}>
                    No Image Available
                  </span>
                </div>
              )}
            </div>
            <h4 className="text-center mb-3">{program_name}</h4>
            <p className="text-justify">{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoModal;
